import { render, staticRenderFns } from "./DiceForm.vue?vue&type=template&id=3a313de6&"
import script from "./DiceForm.vue?vue&type=script&lang=js&"
export * from "./DiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports